import Head from "next/head";
import React from "react";
import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const Phone = dynamic(() => import("../components/phone"), {
  ssr: false,
});

import MainPage from "@/app/main";

const SITE_URL = "https://inter-nation.uz";

export default function Home() {
  const { t } = useTranslation();
  const { locale = "uz" } = useRouter();

  const canonical =
    locale === "uz" ? `${SITE_URL}/` : `${SITE_URL}/${locale}`;

  const ogTitle =
    locale === "ru"
      ? "Inter Nation English School — №1 центр английского и IELTS в Узбекистане"
      : locale === "en"
      ? "Inter Nation English School — #1 English & IELTS center in Uzbekistan"
      : "Inter Nation English School — O'zbekistondagi #1 ingliz tili va IELTS markazi";

  const ogDesc =
    locale === "ru"
      ? "С 2013 года. 23 000+ студентов, 14 филиалов (13 физических + Онлайн), 5+ преподавателей с IELTS 9.0. Лицензированная программа Oxford University Press и авторская IELTS-X."
      : locale === "en"
      ? "Since 2013. 23,000+ students, 14 branches (13 physical + Online), 5+ teachers with IELTS Band 9.0. Licensed Oxford University Press curriculum and proprietary IELTS-X program."
      : "2013 yildan. 23,000+ talaba, 14 filial (13 jismoniy + Online), 5+ IELTS 9.0 o'qituvchi. Oxford University Press litsenziyali dasturi va mualliflik IELTS-X kursi.";

  return (
    <>
      <Head>
        <title>{t("TAB_TITLE")}</title>

        <meta name="description" content={t("META_DESCRIPTION")} />

        {/* Focused keywords — own brand + main intents only. No competitor stuffing. */}
        <meta
          name="keywords"
          content="Inter Nation, Inter Nation English School, ingliz tili kurslari Toshkent, IELTS kurslari Toshkent, IELTS-X, ingliz tili o'quv markazi, English courses Uzbekistan, IELTS preparation Uzbekistan, IELTS Tashkent, English school Tashkent, курсы английского Ташкент, курсы IELTS Узбекистан"
        />

        <link rel="canonical" href={canonical} />
        <link rel="alternate" hrefLang="uz" href={`${SITE_URL}/`} />
        <link rel="alternate" hrefLang="en" href={`${SITE_URL}/en`} />
        <link rel="alternate" hrefLang="ru" href={`${SITE_URL}/ru`} />
        <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/`} />

        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={ogDesc} />
        <meta
          property="og:image"
          content="https://inter-nation.uz/banner.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="Inter Nation English School" />
        <meta
          property="og:locale"
          content={
            locale === "ru" ? "ru_RU" : locale === "en" ? "en_US" : "uz_UZ"
          }
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={ogTitle} />
        <meta name="twitter:description" content={ogDesc} />
        <meta
          name="twitter:image"
          content="https://inter-nation.uz/banner.png"
        />
      </Head>

      <MainPage />
      <Phone />
    </>
  );
}

export async function getStaticProps(context: any) {
  const { locale } = context;

  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
    revalidate: 3600,
  };
}
